import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudInnerStorageFetcher } from 'core/types/CrudInnerStorageFetcher'

import { IEspSponsorOption } from '../model/types'

// The sponsor directory: App Designer form 2111, kept by the program team.
export const ESP_SPONSOR_LIST = { formId: 2111, code: 'esp-sponsor-list' }

// The dropdown's own filter, not the Crud's: DropdownDynamic refetches once its filter turns from undefined into an
// empty one after the first search debounce, and a set filter stays equal, so the list loads once.
export const ESP_ACTIVE_SPONSORS_FILTER: IDataProviderFilter = {
  logic: Logic.AND,
  filters: [{ field: 'IsActive', operator: Operator.EQUAL, value: '1' }],
}

export const createEspSponsorsCrud = () =>
  new Crud<IEspSponsorOption>({
    fetcher: new CrudInnerStorageFetcher<IEspSponsorOption>('EntryId', ESP_SPONSOR_LIST),
    // The dropdown writes the key into the form, and the service stores the sponsor's name.
    keyField: 'Name',
    defaultSort: { field: 'Name', dir: 'asc' },
    defaultPaging: { page: 0, pageSize: 1000 },
  })
